import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BadgeListLayer from "../components/BadgeListLayer";

const BadgeCreationPage = () => {
    return (
        <MasterLayout>
            <BadgeListLayer />
        </MasterLayout>
    );
};

export default BadgeCreationPage;
